export default function getInitials(name) {
    if (!name) return ''; 
    return name
        .split(' ') 
        .map(word => word.charAt(0).toUpperCase())
        .join(''); 
}